import { render, staticRenderFns } from "./GasStatusTag.vue?vue&type=template&id=5794d5db&scoped=true"
import script from "./GasStatusTag.vue?vue&type=script&lang=js"
export * from "./GasStatusTag.vue?vue&type=script&lang=js"
import style0 from "./GasStatusTag.vue?vue&type=style&index=0&id=5794d5db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5794d5db",
  null
  
)

export default component.exports